import React from "react";

const VenderReview = () => {
    return(
        <>
        I am VenderReview.
        </>
    )
}

export default VenderReview;